import resolveAfter from './resolve-after';

function loadImages(images, maxWait = 5000) {
  images = Array.isArray(images) ? images : [images];

  return Promise.all(
    images.map((src) => {
      return resolveAfter(
        new Promise((resolve, reject) => {
          const image = new Image();
          image.onload = resolve;
          image.src = src;
        }),
        maxWait
      );
    })
  );
}

export default loadImages;
